// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid_Extra from "../Data.Monoid.Extra/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Environment from "../Restaumatic.Environment/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic_OldForm from "../Restaumatic.OldForm/index.js";
import * as Restaumatic_Order_Types from "../Restaumatic.Order.Types/index.js";
import * as Restaumatic_Orders_Types_FulfillmentMethodType from "../Restaumatic.Orders.Types.FulfillmentMethodType/index.js";
import * as Restaumatic_Prelude_Specular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic_Site_Components_DeliveryAddress from "../Restaumatic.Site.Components.DeliveryAddress/index.js";
import * as Restaumatic_Site_Components_QrWaiter from "../Restaumatic.Site.Components.QrWaiter/index.js";
import * as Restaumatic_Site_Translations_Keys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Restaumatic_Storage from "../Restaumatic.Storage/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Extra_Switch from "../Specular.Extra.Switch/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Utils_JS_Tooltip from "../Utils.JS.Tooltip/index.js";
var fromFulfillmentMethodType = function (v) {
    if (v instanceof Restaumatic_Orders_Types_FulfillmentMethodType.Delivery) {
        return new Restaumatic_Order_Types.DeliveryMethodShipment(Type_Proxy["Proxy"].value);
    };
    if (v instanceof Restaumatic_Orders_Types_FulfillmentMethodType.Takeaway) {
        return Restaumatic_Order_Types.DeliveryMethodPickup.value;
    };
    if (v instanceof Restaumatic_Orders_Types_FulfillmentMethodType.DineIn) {
        return new Restaumatic_Order_Types.DeliveryMethodDineIn(Type_Proxy["Proxy"].value);
    };
    if (v instanceof Restaumatic_Orders_Types_FulfillmentMethodType.NoContactDelivery) {
        return new Restaumatic_Order_Types.DeliveryMethodNoContactDelivery(Type_Proxy["Proxy"].value);
    };
    throw new Error("Failed pattern match at Restaumatic.Site.Components.DeliveryMethod (line 74, column 3 - line 78, column 85): " + [ v.constructor.name ]);
};
var deliveryMethodSelect = function (initial) {
    return function (options) {
        return Specular_Dom_Element.el_("div")(Restaumatic_OldForm.radioGroupFieldInitiallyEmpty(Restaumatic_Order_Types.eqDeliveryMethod(Data_Eq.eqProxy)(Data_Eq.eqProxy))({
            label: Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.order.delivery_method),
            initial: initial,
            options: Data_Array.filter(function (v) {
                return Data_Foldable.elem(Data_Foldable.foldableArray)(Restaumatic_Order_Types.eqDeliveryMethod(Data_Eq.eqProxy)(Data_Eq.eqProxy))(v)(options);
            })([ new Restaumatic_Order_Types.DeliveryMethodNoContactDelivery(Type_Proxy["Proxy"].value), new Restaumatic_Order_Types.DeliveryMethodShipment(Type_Proxy["Proxy"].value), Restaumatic_Order_Types.DeliveryMethodPickup.value, new Restaumatic_Order_Types.DeliveryMethodDineIn(Type_Proxy["Proxy"].value) ]),
            required: true,
            testId: function (v) {
                if (v instanceof Restaumatic_Order_Types.DeliveryMethodPickup) {
                    return "FulfillmentMethod/Pickup";
                };
                if (v instanceof Restaumatic_Order_Types.DeliveryMethodShipment) {
                    return "FulfillmentMethod/Shipment";
                };
                if (v instanceof Restaumatic_Order_Types.DeliveryMethodNoContactDelivery) {
                    return "FulfillmentMethod/NoContactDelivery";
                };
                if (v instanceof Restaumatic_Order_Types.DeliveryMethodDineIn) {
                    return "FulfillmentMethod/DineIn";
                };
                throw new Error("Failed pattern match at Restaumatic.Site.Components.DeliveryMethod (line 120, column 11 - line 124, column 65): " + [ v.constructor.name ]);
            },
            display: function (v) {
                return function (_selected) {
                    if (v instanceof Restaumatic_Order_Types.DeliveryMethodPickup) {
                        return Specular_Dom_Element.text(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.delivery_method.pickup));
                    };
                    if (v instanceof Restaumatic_Order_Types.DeliveryMethodShipment) {
                        return Specular_Dom_Element.text(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.delivery_method.shipment));
                    };
                    if (v instanceof Restaumatic_Order_Types.DeliveryMethodNoContactDelivery) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.text(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.delivery_method.no_contact_delivery_choice) + " "))(function () {
                            return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder)(Restaumatic_Environment.isMobileApp))(function (isMobileApp$prime) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("js-ps-tooltip"), Specular_Dom_Element.attr("title")(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.delivery_method.no_contact_delivery_tooltip)), Specular_Dom_Element.attr("tabindex")("0"), Data_Monoid_Extra.mwhen(Specular_Dom_Element.monoidProp)(isMobileApp$prime)(Specular_Dom_Element.attr("data-bs-placement")("bottom")) ])(Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("icon-help-circled") ])(Restaumatic_Prelude_Specular.wempty)))(function () {
                                    return Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder)(Utils_JS_Tooltip.initPSTooltip(".js-ps-tooltip"));
                                });
                            });
                        });
                    };
                    if (v instanceof Restaumatic_Order_Types.DeliveryMethodDineIn) {
                        return Specular_Dom_Element.text(Restaumatic_I18n.translate_(Restaumatic_Site_Translations_Keys.t.delivery_method.dine_in));
                    };
                    throw new Error("Failed pattern match at Restaumatic.Site.Components.DeliveryMethod (line 126, column 11 - line 142, column 58): " + [ v.constructor.name ]);
                };
            }
        })("")(""));
    };
};
var deliveryMethodKey = "deliveryMethod";
var deliveryMethodSelectWithStorage = function (options) {
    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Restaumatic_Storage.readStoredValue(Restaumatic_Order_Types.decodeDeliveryMethodType)(Specular_Dom_Builder.monadReaderBuilder)(Specular_Dom_Builder.monadEffectBuilder)(deliveryMethodKey))(function (storedMethod) {
        return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(deliveryMethodSelect(storedMethod)(options))(function (value) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Restaumatic_Storage.storeValue(Foreign_Generic_Class.maybeEncode(Restaumatic_Order_Types.encodeDeliveryMethodType))(Specular_Dom_Builder.monadReaderBuilder)(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(deliveryMethodKey)(Specular_FRP_Base.changed(value)))(function () {
                return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(value);
            });
        });
    });
};
var deliveryMethodWidget = function (config) {
    var customizedDeliveryAddressWidget = Restaumatic_Site_Components_DeliveryAddress.autolocatingDeliveryAddressWidget({
        withAptInfo: config.withAptInfo,
        withEmptyMessage: !config.withAptInfo,
        country: config.country,
        accountId: config.accountId,
        restaurantId: new Data_Maybe.Just(config.restaurantId),
        visible: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(true)
    });
    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Restaumatic_Site_Components_QrWaiter.readDineInLocation(Specular_Dom_Builder.monadReaderBuilder)(Specular_Dom_Builder.monadEffectBuilder))(function (dineInLocation) {
        var $16 = Data_Maybe.isJust(dineInLocation);
        if ($16) {
            return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(new Data_Maybe.Just(new Restaumatic_Order_Types.DeliveryMethodDineIn(new Data_Maybe.Just({
                location: dineInLocation
            })))));
        };
        return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(deliveryMethodSelectWithStorage(Data_Functor.map(Data_Functor.functorArray)(fromFulfillmentMethodType)(config.fulfillmentMethods)))(function (v) {
            return Specular_Extra_Switch.dynamicSwitch(Specular_Extra_Switch.switchDynamic)(Specular_Dom_Builder.monadReplaceBuilder)(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(v)(function (v1) {
                if (v1 instanceof Data_Maybe.Just && v1.value0 instanceof Restaumatic_Order_Types.DeliveryMethodPickup) {
                    return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(new Data_Maybe.Just(Restaumatic_Order_Types.DeliveryMethodPickup.value)));
                };
                if (v1 instanceof Data_Maybe.Just && v1.value0 instanceof Restaumatic_Order_Types.DeliveryMethodShipment) {
                    return Data_Functor.map(Specular_Dom_Builder.functorBuilder)((function () {
                        var $26 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.Just.create);
                        var $27 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Restaumatic_Order_Types.DeliveryMethodShipment.create);
                        return function ($28) {
                            return $26($27((function (v2) {
                                return v2.address;
                            })($28)));
                        };
                    })())(customizedDeliveryAddressWidget);
                };
                if (v1 instanceof Data_Maybe.Just && v1.value0 instanceof Restaumatic_Order_Types.DeliveryMethodNoContactDelivery) {
                    return Data_Functor.map(Specular_Dom_Builder.functorBuilder)((function () {
                        var $29 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.Just.create);
                        var $30 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Restaumatic_Order_Types.DeliveryMethodNoContactDelivery.create);
                        return function ($31) {
                            return $29($30((function (v2) {
                                return v2.address;
                            })($31)));
                        };
                    })())(customizedDeliveryAddressWidget);
                };
                if (v1 instanceof Data_Maybe.Just && v1.value0 instanceof Restaumatic_Order_Types.DeliveryMethodDineIn) {
                    return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(new Data_Maybe.Just(new Restaumatic_Order_Types.DeliveryMethodDineIn(new Data_Maybe.Just({
                        location: Data_Maybe.Nothing.value
                    })))));
                };
                if (v1 instanceof Data_Maybe.Nothing) {
                    return Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Data_Maybe.Nothing.value));
                };
                throw new Error("Failed pattern match at Restaumatic.Site.Components.DeliveryMethod (line 56, column 7 - line 61, column 39): " + [ v1.constructor.name ]);
            }));
        });
    });
};
export {
    deliveryMethodWidget
};
//# sourceMappingURL=index.js.map
